import React, { useState, useEffect } from "react";
import style from "css/template.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import AdminHeader from "components/admin/adminHeader";
import { useMediaQuery } from "react-responsive";
import SideMenu from "components/common/sideMenu";

/**
 * Version : 1.0
 * 작성일자 : 2023-12-11
 * 작성자 : 권도훈
 * 설명 : 공통 템플릿 영역
 */
function Header() {
  //navigate
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isHoverMenu, setIsHoverMenu] = useState(false);

  //반응형
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1450px)",
  });
  const menuList = [
    {
      label: "CAD/CAM",
      key: "CAD",
    },
    {
      label: "Microsoft",
      key: "Microsoft",
    },
    {
      label: "Adobe",
      key: "Adobe",
    },
    {
      label: "랜더링",
      key: "Landering",
    },
    {
      label: "문서/자산관리",
      key: "Documents",
    },
    {
      label: "보안 솔루션",
      key: "Security",
    },
    {
      label: "고객센터",
      key: "Announcement",
    },
  ];
  const menuHandler = (e) => {
    navigate(process.env.REACT_APP_CLIENT_URL + e);
    setIsHoverMenu(false);
  };
  const menuHandlersub = (e, t) => {
    navigate(process.env.REACT_APP_CLIENT_URL + e, {
      state: {
        title: t,
      },
    });
    setIsHoverMenu(false);
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollHeader, setScrollHeader] = useState(false);

  // Scroll 위치를 감지
  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };

  useEffect(() => {
    window.addEventListener("scroll", updateScroll);
    return () => {
      window.removeEventListener("scroll", updateScroll);
    };
  }, []);

  // scroll 위치가 100이하라면 투명한 배경색을 지정하고, 아니면 흰색을 지정한다.
  useEffect(() => {
    if (scrollPosition < 100) {
      setScrollHeader(false);
    } else {
      setScrollHeader(true);
    }
  }, [scrollPosition]);

  const submenucompany = (val) => {
    navigate(process.env.REACT_APP_CLIENT_URL + "company", {
      state: {
        title: val,
      },
    });
    setIsHoverMenu(false);
  };
  const location = useLocation();
  const [loc, setLoc] = useState(false);

  useEffect(() => {
    if (location.pathname === "/Landering") {
      setLoc(true);
    } else if (location.pathname === "/Adobe") {
      setLoc(true);
    } else {
      setLoc(false);
    }
  }, [location]);

  const renderSubMenu = (key) => {
    switch (key) {
      case "CAD":
        return (
          <div className={style.side1}>
            <div className={style.sub_menu}>
              <div className={style.sub_menu_group}>
                <div className={style.sub_menu_list}>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 1)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      ZWCAD 2025
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 2)}
                  >
                    <div className={style.sub_menu_list_item_name}>AutoCAD</div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 3)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      ZW3D 2025
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case "Microsoft":
        return (
          <div className={style.side2}>
            <div className={style.sub_menu}>
              <div className={style.sub_menu_group}>
                <div className={style.sub_menu_list}>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 1)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      Windows 11 Pro
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 2)}
                  >
                    <div className={style.sub_menu_list_item_name}>Office</div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 3)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      Microsoft 365
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case "Adobe":
        return (
          <div className={style.side3}>
            <div className={style.sub_menu}>
              <div className={style.sub_menu_group}>
                <div className={style.sub_menu_list}>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 1)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      Creative Cloud
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 2)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      Photoshop/Illustrator
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 3)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      Acrobat Pro
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case "Landering":
        return (
          <div className={style.side4}>
            <div className={style.sub_menu}>
              <div className={style.sub_menu_group}>
                <div className={style.sub_menu_list}>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 1)}
                  >
                    <div className={style.sub_menu_list_item_name}>KeyShot</div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 2)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      Rhinoceros
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 3)}
                  >
                    <div className={style.sub_menu_list_item_name}>Lumion</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case "Documents":
        return (
          <div className={style.side5}>
            <div className={style.sub_menu}>
              <div className={style.sub_menu_group}>
                <div className={style.sub_menu_list}>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 1)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      Foxit PDF Editor
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 2)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      Office HWP(한글)
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 3)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      넷클라이언트
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case "Security":
        return (
          <div className={style.side6}>
            <div className={style.sub_menu}>
              <div className={style.sub_menu_group}>
                <div className={style.sub_menu_list}>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 1)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      AhnLab V3
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 2)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      <label> Bitdefender GravityZone</label>
                      <label> Business Security</label>
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub(key, 3)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      <label> Bitdefender GravityZone</label>
                      <label> Business Security</label>
                      <label> Enterprise</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case "Announcement":
        return (
          <div className={style.side7}>
            <div className={style.sub_menu}>
              <div className={style.sub_menu_group}>
                <div className={style.sub_menu_list}>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub("Announcement", 1)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      공지사항
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub("Event", 2)}
                  >
                    <div className={style.sub_menu_list_item_name}>이벤트</div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub("Free", 3)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      무료체험
                    </div>
                  </div>
                  <div
                    className={style.sub_menu_list_item}
                    onClick={() => menuHandlersub("Request", 4)}
                  >
                    <div className={style.sub_menu_list_item_name}>
                      견적요청
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return <></>;
    }
  };

  const [isOpenMenu, setIsOpenMenu] = useState(false);

  const handleMenu = () => {
    setIsOpenMenu(!isOpenMenu);
    if (!isOpenMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
  };

  useEffect(() => {
    if (!isMobile && !isTablet && isOpenMenu) {
      setIsOpenMenu(!isOpenMenu);
      document.body.style.overflow = "hidden";
    }
  }, [isMobile, isTablet, isOpenMenu]);

  return (
    <>
      {pathname === "/admin" ? (
        <></>
      ) : pathname.includes("/admin/") ? (
        <AdminHeader />
      ) : (
        <>
          {isOpenMenu ? <SideMenu close={() => handleMenu()} /> : <></>}
          <div
            className={
              scrollHeader || isOpenMenu
                ? style.scrollHeader
                : loc
                ? `${style.header} ${style.header_black}`
                : style.header
            }
          >
            <div
              className={
                isHoverMenu
                  ? `${style.header_main} ${style.header_hover}`
                  : style.header_main
              }
            >
              <div className={style.header_fix}>
                <div className={style.header_left_area}>
                  <img
                    className="cursor"
                    alt=""
                    src={
                      scrollHeader || isOpenMenu || isHoverMenu || loc
                        ? "/img/common/blue_logo.png"
                        : "/img/common/logo.png"
                    }
                    onClick={() => {
                      if (isOpenMenu) {
                        handleMenu();
                      }
                      navigate(process.env.REACT_APP_CLIENT_URL);
                    }}
                  />
                </div>

                {isMobile || isTablet ? (
                  <div className={style.header_right_area}>
                    <div
                      className={
                        isOpenMenu
                          ? `${style.menu_btn} active`
                          : `${style.menu_btn}`
                      }
                      onClick={() => handleMenu()}
                    >
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                ) : (
                  <div className={style.header_right_area}>
                    {menuList.map((menu) => (
                      <div
                        key={menu.key}
                        className={style.menu}
                        onClick={() => menuHandler(menu.key)}
                        onMouseEnter={() => {
                          setIsHoverMenu(true);
                        }}
                        onMouseLeave={() => {
                          setIsHoverMenu(false);
                        }}
                      >
                        <span
                          style={{ cursor: "pointer" }}
                          className={isHoverMenu || loc ? style.hover_span : ""}
                        >
                          {menu.label}
                        </span>
                        {isHoverMenu ? (
                          <div
                            onClick={
                              ((e) => e.preventDefault(),
                              (e) => e.stopPropagation())
                            }
                          >
                            {renderSubMenu(menu.key)}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {!isMobile && !isTablet && isHoverMenu ? (
              <div
                className={style.header_sub}
                onMouseEnter={() => {
                  setIsHoverMenu(true);
                }}
                onMouseLeave={() => {
                  setIsHoverMenu(false);
                }}
              ></div>
            ) : (
              <></>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default Header;
